import AgencyMark from '../marks/AgencyMark'
import { usePrefs } from '@/state/prefs'
import { markStyleInfo, markStyles } from '@/content/marks'
import type { Mission } from '@/content/missions'

/** Every mark style for one mission, each selectable as the site-wide style. */
export default function MissionMarks({ mission }: { mission: Mission }) {
  const { prefs, set } = usePrefs()
  return (
    <ul className="msn-marks" data-mission={mission.id}>
      {markStyles.map((style) => (
        <li key={style}>
          <button
            type="button"
            className="msn-marks__option"
            aria-pressed={prefs.mark === style}
            onClick={() => set('mark', style)}
          >
            <span className="msn-marks__art">
              <AgencyMark mission={mission} variant={style} />
            </span>
            <span className="msn-marks__label">{markStyleInfo[style].name}</span>
            <span className="msn-marks__note">{markStyleInfo[style].note}</span>
          </button>
        </li>
      ))}
    </ul>
  )
}
